import { instance } from '@/plugins/api'

export function getToken (params) {
  return instance.get('https://resources.suzi.com.cn/gnsl_obs/temp/token', params)
}
